import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import {
  asyncValidateUsername,
  validateUsername,
  validatePassword,
} from "../../../services/validation";
import { registerAction } from "../../../redux/actions/auth.actions";
import { renderErrorsList } from "../../../utils/formUtils";
import InputField from "../InputField";
import FaceBookAuthButton from "../../FaceBookAuthButton";
import { checkUsernameExists } from "../../../services/profile.service";

export class RegisterForm extends React.Component {
  handleRegistration = values => {
    this.props.register(values.username, values.password);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="col-lg-3 col-md-4 col-sm-6 col-6 text-center form-margin-container">
        <h3 id="sign-in-brand">New User Registration</h3>
        <br />
        <form onSubmit={handleSubmit(this.handleRegistration)}>
          <Field
            label="username"
            name="username"
            type="text"
            id="username-input"
            hideLabel={true}
            component={InputField}
            placeholder="Username"
            textAlign="center"
            required
          />
          <Field
            label="Password"
            name="password"
            type="password"
            id="password-input"
            hideLabel={true}
            component={InputField}
            textAlign="center"
            placeholder="Password"
            required
          />
          <Field
            label="ConfirmePassword"
            name="confirmPassword"
            type="password"
            id="confirm-password-input"
            hideLabel={true}
            component={InputField}
            textAlign="center"
            placeholder="Confirm Password"
            required
          />
          <br />
          <button type="submit" id="login-btn" className="btn btn-primary">
            Sign in
          </button>
        </form>

        <br />
        {/*<ul className="list-group">{renderErrorsList(this.props.auth.errors)}</ul>*/}

        {/*<div className="strike">*/}
        {/*  <span>*/}
        {/*    <i>or</i>*/}
        {/*  </span>*/}
        {/*</div>*/}
        {/*<br />*/}
        {/*<FaceBookAuthButton />*/}

        {/*<a className="btn btn-block fb-button">*/}
        {/*<i className="fab fa-facebook-f fb-icon"></i>*/}
        {/*Sign in with Facebook*/}
        {/*</a>*/}
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const usernameErrors = validateUsername(values.username);
  const passwordErrors = validatePassword(values.password);

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return { ...errors, ...passwordErrors, ...usernameErrors };
}

function mapStateToProps({ auth }, ownProps) {
  return { auth };
}

const connectedReduxForm = reduxForm({
  validate,
  asyncValidate: asyncValidateUsername,
  asyncChangeFields: ['username'],
  form: "RegisterForm"
})(
  connect(
    mapStateToProps,
    { register: registerAction }
  )(RegisterForm)
);

export default connectedReduxForm;



// WEBPACK FOOTER //
// ./src/components/forms/RegisterForm/RegisterForm.jsx